import PatternSymbol from './PatternSymbol';

export default PatternSymbol;
